import { HeaderSEOBlockByPinContainer } from '@/microfrontends/listing/shared/containers/HeaderSEOBlockContainer';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { SEOBlockLayout } from './components/SEOBlockLayout';

export const SEOBlockByPin = memoWithDisplayName(() => {
  const isNarrow = useListingLayoutIsNarrowSelector();

  return (
    <SEOBlockLayout
      header={<HeaderSEOBlockByPinContainer />}
      isNarrow={isNarrow}
      quickLinks={null}
      viewModeSwitcher={null}
    />
  );
}, 'SEOBlockByPin');
